import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import useEndSlateImages from "../../data/useEndSlateImages";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import Modal from "../../layouts/Modal";
import ConfirmModal from "../shared/Confirm/ConfirmModal";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import FileUpload from "../shared/Inputs/FileUpload";
import { NumberInput } from "../shared/Inputs/NumberInput";
import { IPartImage } from './../../models/Part';

type FormValues = {
  endSlateOrder?: number | null;
};

interface EndSlateModalModalProps {
  open: boolean,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  endSlate?: IPartImage;
}

export default function EndSlateModal({ open, setOpen, endSlate }: EndSlateModalModalProps) {
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("End Slate");
  const { update, upload, remove } = useEndSlateImages();
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const { register, handleSubmit, reset } = useForm<FormValues>();

  const [toUpload, setToUpload] = useState([]);
  const updateToUploadFiles = (files: any) => setToUpload({ ...files });

  const onSubmit = (data: FormValues) => {
    const updatedSlate = {
      ...endSlate,
      endSlateOrder: data.endSlateOrder ? data.endSlateOrder : null,
    };

    console.log(updatedSlate);

    if (endSlate) {
      update.mutate(updatedSlate, {
        onSuccess: (data) => {
          saveHandlers.onSuccess();
          setOpen(false);
          reset({});
        },
        onError: saveHandlers.onError
      });

    } else {

      if (toUpload.length < 1) {
        // saveHandlers.onError("Please upload a file before submitting.");
        return;
      }

      const formData = new FormData();

      formData.append("endSlate", toUpload[0]);

      console.log(toUpload)
      console.log(formData)

      upload.mutate(formData, {
        onSuccess: (data) => {
          saveHandlers.onSuccess();
          setOpen(false);
          reset({});
        },
        onError: saveHandlers.onError
      });
    }
  };

  const handleDelete = () => {
    remove.mutate(endSlate?.id!, {
      onSuccess: (data) => {
        deleteHandlers.onSuccess();
        setOpen(false);
        setDeleteOpen(false);
        reset({});
      },
      onError: deleteHandlers.onError
    });
  };

  useEffect(() => {
    if (endSlate) {
      reset({ ...endSlate });
    } else {
      reset({ endSlateOrder: null });
    }
  }, [endSlate, open, reset]);

  return (
    <>
      <ConfirmModal open={deleteOpen} setOpen={setDeleteOpen}
        title={"Delete End Slate"} message={`Are you sure you want to delete this end slate?\n This action cannot be undone.`}
        confirmButtonText={"Delete"} onConfirm={handleDelete} isLoading={false}
      />
      <Modal width="max-w-[40vw]" open={open} setOpen={setOpen} >
        <div className="flex justify-between">
          <h1 className="text-xl">{`${endSlate ? "Edit" : "Add"} an End Slate`}</h1>
        </div>
        <div className="mt-4">
          <form className="space-y-4 border-t border-gray-200" onSubmit={handleSubmit(onSubmit)} >

            {!endSlate && (
              <FileUpload
                label={"Upload End Slate Here"}
                accept=".jpg,.png,.jpeg"
                desc="Upload a picture that will be added to the end of every eBay listing..."
                updateFilesCb={updateToUploadFiles}
              />
            )}

            {endSlate && (
              <NumberInput label="Order (Leave empty to switch off)" registerName="endSlateOrder" register={register} />
            )}

            <div className="flex gap-x-4">
              <ButtonInput label={`${endSlate ? "Save Changes" : "Upload"}`} isSubmit={true} onClick={undefined} classes={undefined} />
              {endSlate && (
                <>
                  <ButtonInput label={"Delete"} isSubmit={false} onClick={() => (setDeleteOpen(true))} classes={"!bg-red-500 hover:!bg-red-600"} />
                </>
              )}
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
}
